module.exports = __webpack_public_path__ + "static/img/antontong.6b07babf.png";